module.exports = __webpack_public_path__ + "img/CPTemp8.cd2751d8.png";